<template>
    <div class="animated fadeIn bike">
    <h1 class="title">Dashboard</h1>
        <b-row class="mtop25">
            <b-col md="6" sm="6" lm="4" xs="12">
                <div class="brand-card">
                    <div class="brand-card-body">
                        <div v-if="userData">
                            <i class="text-muted fa fa-user-o p-4 px-4 font-4xl mr-2"></i>
                            <div class="text-value">{{ totalSessions }}</div>
                            <div class="text-uppercase text-muted small"> {{ $tc("messages.session", totalSessions ) }}</div>
                        </div>
                        <div v-if="userData">
                            <i class="text-muted fa fa-clock-o p-4 px-4 font-4xl mr-2"></i>
                            <div class="text-value">{{ totalTime }}</div>
                            <div class="text-uppercase text-muted small">{{ $t("messages.time") }}</div>
                        </div>
                        <div v-if="userData">
                            <i class="text-muted fa fa-road p-4 px-4 font-4xl mr-2"></i>
                            <div class="text-value">{{ parseFloat( totalDistance / 1000).toFixed(2) }} km</div>
                            <div class="text-uppercase text-muted small">{{ $t("messages.distance") }}</div>
                        </div>
                        <div v-if="dataCompleted">
                            <i class="text-muted fa fa-signal p-4 px-4 font-4xl mr-2"></i>
                            <div class="text-value">{{ parseInt( (totalEnergy) / 10) }}</div>
                            <div class="text-uppercase text-muted small">KCAL</div>
                        </div>  
                    </div>
                </div>
            </b-col>
            <b-col md="6" sm="6" lm="4" xs="12">
                <div class="brand-card">
                    <div class="brand-card-body" v-if="dataCompleted" >
                        <doughnut :height="80" :cycling="cycling" :treadmill="treadmill" :elliptical="elliptical"/>
                    </div>
                  </div>
            </b-col>
        </b-row>
        <b-card>
            <b-row>
                <b-col sm="5">
                    <h4 id="traffic" class="card-title mb-0">{{ $tc("messages.average", 2) }}</h4>
                </b-col>
                <b-col sm="7" class="d-none d-md-block">
                    <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
                    <b-form-radio-group class="mr-3" id="radiosBtn" buttons button-variant="outline-secondary" v-model="selectedRadio" name="radiosBtn">
                        <b-form-radio class="mx-0" value=31>{{ $t("messages.lastMonth") }}</b-form-radio>
                        <b-form-radio class="mx-0" value=7>{{ $t("messages.lastWeek") }}</b-form-radio>
                    </b-form-radio-group>
                    </b-button-toolbar>
                </b-col>
            </b-row>
            <global-data v-if="dataCompleted" chartId="main-chart-01" class="chart-wrapper" style="height:300px;" height="300" :range="selectedRadio"></global-data>
        </b-card>
    </div>
</template>

<script>
import GlobalData from './GlobalData'
import { mapState } from 'vuex'
import Doughnut from './charts/Doughnut'

export default {
    name: 'globalview',
    components: {
        GlobalData,
        Doughnut
    },
    data() {
        return {
           selectedRadio: 7,
           totalSessions:0,
           totalDistance: 0,
           totalTime: 0,
           totalEnergy:0,
           cycling:0,
           treadmill:0,
           elliptical:0,
           dataCompleted:false
        }
    },

  created(){
      this.$nextTick( () =>{
        this.$store.dispatch("getUserStravaInfo").then(image => {
            this.totalSessions = this.getTotalized(this.userData,'sessions')
            this.totalDistance = this.getTotalized(this.userData,'distance')
            this.totalTime = this.getTotalizedTime(this.userData,'time')
            this.totalEnergy = this.getTotalized(this.userData,'energy')
            this.cycling = this.getTotalSessions(this.userData, 'cycling')
            this.treadmill = this.getTotalSessions(this.userData, 'treadmill')
            this.elliptical = this.getTotalSessions(this.userData, 'elliptical')
            this.dataCompleted = true
        }, error=>{
           console.log(error)
        })
      })
  },
    computed: {
    ...mapState(['userData'])

  },  
  methods:{
    getTotalSessions(userData, type){
        try{
            var _total = (userData && userData[type].sessions) ? userData[type].sessions : 0;
            return _total
        }catch(error){
            console.log(error)
        }
   
    },
    getTotalized(userData, type){
        try{
            let _cycling =  (userData && userData.cycling[type]) ?  userData.cycling[type] : 0;
            let _treadmill = (userData && userData.treadmill[type]) ? userData.treadmill[type] : 0;
            let _elliptical = (userData && userData.elliptical[type]) ?  userData.elliptical[type] : 0;
        return _cycling + _treadmill + _elliptical
        }catch(error){
            console.log(error)
        }
   
    },
    getTotalizedTime(userData, type){
    try{
        let _cycling =  (userData && userData.cycling[type]) ?  userData.cycling[type] : 0;
        let _treadmill = (userData && userData.treadmill[type]) ? userData.treadmill[type] : 0;
        let _elliptical = (userData && userData.elliptical[type]) ?  userData.elliptical[type] : 0;
        return this.getTotalTime(_cycling + _treadmill + _elliptical)
          }catch(error){
            console.log(error)
        }
    },
    getTotalTime(duration) {
      var t = duration * 1000;
      var d = this.$moment.duration(t);
      var s = Math.floor(d.asHours()) + this.$moment.utc(t).format(":mm");
      return s;
    }
  }
}
</script>

<style >
.text-value {
    font-size: 1rem;
} 
.brand-card-body {
    padding: 0!important;
    max-height: 320px;
} 
.brand-card-header {
    height: 0;
} 

</style>



// WEBPACK FOOTER //
// src/components/GlobalView.vue